import React, { useState, useEffect, useContext } from 'react';

import ContentsMainBox from '../../components/common/ContentsMainBox';
import ContentsBox from '../../components/common/ContentsBox';

import HomeVodSkeleton from '../../components/skeleton/HomeVodSkeleton';
import { LayoutContext } from '../../context/layoutContext';

import Flicking from '@egjs/react-flicking';

import '@egjs/react-flicking/dist/flicking.css';
import '@egjs/react-flicking/dist/flicking-inline.css';

const MediaList = ({ list, type, playBtn, mainShowCnt, goDetail }) => {
  const [mediaList, setMediaList] = useState([]);

  const { matchese } = useContext(LayoutContext);

  useEffect(() => {
    let _list = [];
    let mainCnt = matchese ? 1 : 1;

    list.map((item, idx) => {
      if (mainShowCnt > 1) {
        if (!matchese) {
          if (idx < 2) {
            item['rep'] = true;
          }
        } else {
          if (idx === 0 || idx === 3) {
            item['rep'] = true;
          }
        }
      } else if (mainShowCnt === 1) {
        if (idx === mainCnt) {
          item['rep'] = true;
        }
      }
      _list.push(item);
    });

    setMediaList(_list);
  }, [list]);

  // 웹
  const listCondition_w = list => {
    return list.map((item, idx) => {
      let result;
      if (item.rep) {
        result = (
          <ContentsMainBox
            data={item}
            type={type}
            key={`vodmain_${idx}`}
            goDetail={() => goDetail(item, type)}
            contetentHeight='320px'
            animation='select'
            imgOpacity={true}
            freePlayBtn={playBtn}
            //
          />
        );
      } else {
        result = (
          <ContentsBox
            type={type}
            data={item}
            key={`vodsub_${idx}`}
            showCompany={true}
            goDetail={() => goDetail(item, type)}
            contetentHeight='180px'
            imgOpacity={true}
            playBtn={playBtn}
            animation='select'
          />
        );
      }
      return result;
    });
  };

  // 모바일
  const listCondition_m = list => {
    let result = [];
    let arr = [];

    list.map((item, idx) => {
      if (item.rep) {
        arr.push(
          <ContentsMainBox
            data={item}
            type={type}
            key={`${type}_vodmain_${idx}`}
            contetentWidth='100%'
            contetentHeight='200px'
            margin='0 0 5px 0'
            goDetail={() => goDetail(item, type)}
            freePlayBtn={playBtn}
            animation='select'
            imgOpacity={true}
            //
          />,
        );
      } else {
        arr.push(
          <ContentsBox
            type={type}
            data={item}
            key={`${type}_vodmain_${idx}`}
            showCompany={true}
            playBtn={playBtn}
            imgOpacity={true}
            width='50%'
            contetentHeight='130px'
            goDetail={() => goDetail(item, type)}
            animation='select'
          />,
        );
      }

      if (idx === 2) {
        result.push(arr);
        arr = [];
      }
      if (idx === list.length - 1) {
        result.push(arr);
        arr = [];
      }
    });

    let group = [];
    return (
      <Flicking circular={false}>
        {result.map((panel, idx) => (
          <div className='filcking_panel' key={`${panel}_${idx}`} style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
            {panel.map((item, idx) => {
              if (idx === 0) {
                return item;
              }

              if (idx > 0) {
                group.push(item);
              }

              if (idx === panel.length - 1) {
                let _group = group;
                group = [];

                return (
                  <div key={`sub_${item}_${idx}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                    {_group.map(sub => sub)}
                  </div>
                );
              }
            })}
          </div>
        ))}
      </Flicking>
    );
  };

  return (
    <>
      {mediaList.length > 0 && (
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            padding: '15px 0 0',
            justifyContent: 'flex-start',
          }}
        >
          {mediaList.length > 0 ? matchese ? listCondition_m(mediaList) : listCondition_w(mediaList) : <HomeVodSkeleton />}
        </div>
      )}
    </>
  );
};

export default MediaList;
